import { buildModelManager } from "../builder.js";
const DefaultImportBatchSelection = {
  __typename: true,
  id: true,
  completedAt: true,
  createdAt: true,
  errorRows: true,
  errors: true,
  processedRowIndices: true,
  processedRows: true,
  profileId: true,
  recordType: true,
  source: true,
  startedAt: true,
  status: true,
  totalRows: true,
  updatedAt: true
};
const modelApiIdentifier = "importBatch";
const pluralModelApiIdentifier = "importBatches";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultImportBatchSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultImportBatchSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultImportBatchSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultImportBatchSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultImportBatchSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultImportBatchSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultImportBatchSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "importBatchGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ImportBatchManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultImportBatchSelection,
  operations
);
export {
  DefaultImportBatchSelection,
  ImportBatchManager
};
//# sourceMappingURL=ImportBatch.js.map
